import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateCorporateActionEventCommand extends ModelBase {
    public corporateActionEventID: number = 0;

    public corporateActionStatusID: number = 0;

    public researcherComment: string = "";

    public enactmentComment: string = "";

    public isDeleted: boolean = false;

    public isCompleted: boolean = false;
}